import React, { useEffect } from 'react';
import CartLineItem from './CartLineItem';
import { useCart } from '../../../hooks/useCart';
import { MiniCartHeader } from './Header';
import { MiniCartUnderlay } from './Underlay';
import { MiniCartFooter } from './Footer';

import useLangStrings from '../../../hooks/useLangStrings';
import { MiniCartFreeShippingBar } from './FreeShippingBar';
interface Props {
  dataSet: DOMStringMap;
}

const MiniCart: React.FunctionComponent<Props> = ({ dataSet }: Props) => {
  const { items, openMinicart, getCartState } = useCart();
  const {
    title,
    freeShippingBeforeTargetText,
    freeShippingAfterTargetText,
    // summaryTitle,
    // removeText,
    // lastItemText,
    // orderTitle,
    itemsText,
    itemsTextSingular,
    // savingTitle,
    // subTotalTitle,
    proccedCta: proceedCta,
    // viewCartCta,
    // additionalMinicartHTML,
    // giftProductTitle,
    // giftProductModalTitle,
    // giftProductMessage,
    // addToCartText,
    // giftProductDropdown,
    // addText,

    // New
    addNoteText,
    editNoteText,
    addGiftWrapText,
    saveNoteText,
    addNotePlaceholderText,
  } = useLangStrings(dataSet.langStrings);

  const {
    enableFreeShippingBar,
    freeShippingTargetAmount,
    giftWrapProductId,
    giftWrapProductPrice,
    automaticFreeShippingSkus,
    excludedSkus,
  } = JSON.parse(dataSet.settings) as {
    enableFreeShippingBar: boolean;
    freeShippingTargetAmount: number;
    giftWrapProductId: number;
    giftWrapProductPrice: number;
    automaticFreeShippingSkus: string;
    excludedSkus: string;
  };

  const giftWrapProduct = {
    id: giftWrapProductId,
    price: giftWrapProductPrice,
  };

  useEffect(() => {
    document.addEventListener(
      'octane.quiz.addToCart',
      () => {
        getCartState().then(() => {
          openMinicart();
        });
      },
      false
    );
  }, []);

  return (
    <>
      <MiniCartUnderlay />
      <aside className="minicart">
        <MiniCartHeader
          title={title}
          itemsTextSingular={itemsTextSingular}
          itemsText={itemsText}
        />
        {enableFreeShippingBar && (
          <MiniCartFreeShippingBar
            targetAmount={freeShippingTargetAmount}
            beforeTargetText={freeShippingBeforeTargetText}
            afterTargetText={freeShippingAfterTargetText}
            automaticFreeShippingSkus={automaticFreeShippingSkus}
          />
        )}
        <div className="minicart-scroll-area">
          <div className="minicart-scroll-area-inner">
            <div className="minicart-main">
              <div className="minicart-items">
                {items.length > 0 ? (
                  <ul className="minicart-items-list">
                    {items.map((lineItem) => (
                      <CartLineItem
                        key={lineItem.key}
                        lineItem={lineItem}
                      ></CartLineItem>
                    ))}
                  </ul>
                ) : (
                  <div className="minicart-empty-cart">
                    <h4 className="minicart-empty-cart-title">
                      Your cart is empty!
                    </h4>
                    <p className="minicart-empty-cart-description">
                      Add your favorite items to your cart.
                    </p>
                    <p className="minicart-empty-cart-cta">
                      <a href="/">Shop Now</a>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <MiniCartFooter
          proceedCta={proceedCta}
          addNoteText={addNoteText}
          editNoteText={editNoteText}
          addGiftWrapText={addGiftWrapText}
          giftWrapProduct={giftWrapProduct}
          excludedSkus={excludedSkus}
          saveNoteText={saveNoteText}
          addNotePlaceholderText={addNotePlaceholderText}
        />
      </aside>
    </>
  );
};

export default MiniCart;
